import React, { useEffect, useState } from 'react';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { NavLink, useParams, useHistory } from 'react-router-dom';
// import {
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from '@material-ui/core';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  getExchangeEvents,
  fetchEventsByCompetition,
  setExchEvent,
  setCompetition,
  fetchEventsBySport,
  // setPageNumber,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// import ExchBetslip from '../ExchBetslip/ExchBetslip';
import './ExchEventsTable.scss';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import { IonCol, IonImg, IonRow } from '@ionic/react';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { formatDate, liveImagesMap } from '../../util/stringUtil';
import moment from 'moment';
import ExchMobOddView from '../ExchOddButton/ExchMobOddView';
import { EventDTO } from '../../models/common/EventDTO';
import HomeView from '../../constants/HomeView';
import {
  unsubscribeAllWsforEvents,
  subscribeWsForEventOdds,
  isConnected,
} from '../../webSocket/webSocket';

type StoreProps = {
  events: EventDTO[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  fetchEventsByCompetition: (
    sportId: string,
    competitionId: string,
    events: EventDTO[]
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  setCompetition: (competition: SelectedObj) => void;
  // addExchangeBet: (data: BsData) => void;
  // bets: BsData[];
  fetchEventsBySport: (sportId: string, events: EventDTO[]) => void;
  // pageNum: number;
  // pageSize: number;
  // setPageNumber: (pageNum: number) => void;
  fetchingEvents: boolean;
  allowedConfig: number;
  loggedIn: boolean;
  topicUrls: any;
  langData:any;
};

const Images = HomeView.EVENT_PAGE_IMAGES;

const EventsTable: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    events,
    selectedEventType,
    selectedCompetition,
    fetchEventsByCompetition,
    setExchEvent,
    setCompetition,
    // addExchangeBet,
    // bets,
    fetchEventsBySport,
    // pageNum,
    // pageSize,
    // setPageNumber,
    fetchingEvents,
    loggedIn,
    topicUrls,
    langData
  } = props;

  const pathParams = useParams();
  const teamTypes = ['home', 'draw', 'away'];
  // const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [wsChannels, setWsChannels] = useState<string[]>([]);
  const history = useHistory();

  const tableFields = [
    {
      key: 'schedle',
      Label: langData?.['schedule'],
      className: 'schedule-cell schedule-cell-header',
      align: 'left',
    },
    { 
      key: 'teams', 
      Label: langData?.['teams'],
      className: 'teams-cell', 
      align: 'left' 
    },
    // { key: 'score', Label: 'Score', className: 'score-cell', align: 'center' },
    {
      key: 'homeTeamOdds',
      Label: '1',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'drawOdds',
      Label: 'X',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'awayTeamOdds',
      Label: '2',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'more',
      Label: '',
      className: 'all-markets-link-cell',
      align: 'center',
    },
  ];
  const getOdds = (eventData: EventDTO, teamType: string) => {
    const team =
      teamType === 'home'
        ? eventData.homeTeam
        : teamType === 'away'
        ? eventData.awayTeam
        : teamType;
    for (let runner of eventData.matchOdds.runners) {
      if (
        runner.runnerName.toLowerCase() === team.toLowerCase() ||
        runner.runnerName.toLowerCase().includes(team.toLowerCase())
      ) {
        return [
          {
            type: 'back-odd',
            price: runner?.backPrices[0]?.price,
            size: runner?.backPrices[0]?.size,
            outcomeId: runner.runnerId,
            outcomeName: runner.runnerName,
          },
          {
            type: 'lay-odd',
            price: runner?.layPrices[0]?.price,
            size: runner?.layPrices[0]?.size,
            outcomeId: runner.runnerId,
            outcomeName: runner.runnerName,
          },
        ];
      }
    }
    return null;
  };

  useEffect(() => {
    if (!pathParams['competition']) {
      setCompetition({ id: '', name: '', slug: '' });
    }
  }, [pathParams]);

  const updateEvents = () => {
    if (!pathParams['competition']) {
      fetchEventsBySport(selectedEventType.id, events);
    } else {
      fetchEventsByCompetition(
        selectedEventType.id,
        selectedCompetition.id,
        events
      );
    }
  };

  useEffect(() => {
    if (!pathParams['competition']) {
      fetchEventsBySport(selectedEventType.id, events);

      // if (!(allowedConfig & Number(selectedEventType.id))) {
      //   history.push('/home');
      // }
    }
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition'] && !events) {
      fetchEventsByCompetition(
        selectedEventType.id,
        selectedCompetition.id,
        events
      );
    }
  }, [selectedCompetition]);

  useEffect(() => {
    updateEvents();
  }, [loggedIn]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvents();
    }, 20 * 1000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [selectedEventType]);

  // Unsubscribe Web socket messages
  useEffect(() => {
    unsubscribeAllWsforEvents();
    setWsChannels([]);
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition']) {
      unsubscribeAllWsforEvents();
      setWsChannels([]);
    }
  }, [selectedCompetition, pathParams]);

  useEffect(() => {
    if (loggedIn) {
      if (events) {
        let subs = [...wsChannels];
        for (let event of events) {
          if (event.status === 'IN_PLAY' && !wsChannels.includes(event.eventId)) {
            subs.push(event.eventId);
            subscribeWsForEventOdds(
              topicUrls?.matchOddsTopic,
              event.sportId,
              event.competitionId,
              event.eventId,
              event.matchOdds?.marketId
            );
          }
        }
        setWsChannels(subs);
      }
    }
  }, [isConnected(), events, selectedEventType, loggedIn]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  const disableFutureEvents = (date: any) => {
    let dt = date;
    dt = moment.utc(date).toString();

    let retDate = moment(dt);
    retDate = retDate.local();

    return moment(retDate).diff(moment(), 'minutes') > 60 * 24 * 2
      ? true
      : false;
  };

  const handleEventChange = (event: EventDTO) => {
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: getCompetitionSlug(event.competitionName),
    });
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
  };

  return (
    <div className="events-table-ctn">
      <div className={'banner-container'}>
        <img
          className="banner-image"
          src={Images[selectedEventType.slug.toLowerCase()]?.image}
          key={selectedEventType.slug.toLowerCase() + '-image'}
          alt={'banner'}
          title={selectedEventType.slug}
        />
      </div>
      {events ? (
        events.length > 0 ? (
          <div className="events-table-content table-ctn">
            <TableContainer component={Paper}>
              <Table className="events-table">
                <TableHead>
                  <TableRow>
                    {tableFields.map((tF, index) => (
                      <TableCell
                        key={tF.key + index}
                        align={tF.align === 'left' ? 'left' : 'center'}
                        colSpan={tF.colSpan ? tF.colSpan : 1}
                        className={tF.className}
                      >
                        {tF.Label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {events.map((sEvent, idx) => (
                    <TableRow key={idx}>
                      <TableCell className="schedule-cell">
                        {formatDate(sEvent.openDate)}
                      </TableCell>
                      <TableCell className="teams-cell">
                        <NavLink
                          className="all-markets-nav-link"
                          key={'all-markets-link'}
                          onClick={() => handleEventChange(sEvent)}
                          to={`/exchange_sports/${
                            selectedEventType.slug
                          }/${getCompetitionSlug(sEvent.competitionName)}/${
                            sEvent.eventSlug
                          }/${btoa(
                            `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}`
                          )}`}
                        >
                          {sEvent.homeTeam !== '' && sEvent.awayTeam !== '' ? (
                            <>
                              <div className="web-view">
                                <div className="temas-col">
                                  <div className="teams">
                                    <div className="team-name">
                                      {sEvent.homeTeam}
                                    </div>
                                    <div className="team-name">
                                      {sEvent.awayTeam}
                                    </div>
                                  </div>
                                  {sEvent.status === 'IN_PLAY' ? (
                                    <img
                                      className="live-img"
                                      src={liveImagesMap[selectedEventType.id]}
                                      alt="live"
                                    />
                                  ) : null}
                                </div>
                              </div>
                              <div className="mob-view">
                                <div className="event-name">
                                  {sEvent.eventName}

                                  {sEvent.status === 'IN_PLAY' ? (
                                    <img
                                      className="live-img"
                                      src={liveImagesMap[selectedEventType.id]}
                                      alt="live"
                                    />
                                  ) : null}
                                </div>
                                <div className="schedule-time">
                                  {formatDate(sEvent.openDate)}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="team-name">{sEvent.eventName}</div>
                          )}
                          <IonRow className="mob-odds-row">
                            {teamTypes.map((teamType, index) => (
                              <IonCol
                                className="mob-odds-block"
                                key={teamType + index}
                              >
                                {sEvent.matchOdds ? (
                                  getOdds(sEvent, teamType) ? (
                                    <>
                                      {getOdds(sEvent, teamType).map((odd) => (
                                        <ExchMobOddView
                                          mainValue={odd.price}
                                          oddType={
                                            odd.type === 'back-odd'
                                              ? 'back-odd'
                                              : 'lay-odd'
                                          }
                                          disable={
                                            sEvent.matchOdds.status
                                              .toLowerCase()
                                              .includes('suspended') ||
                                            disableFutureEvents(sEvent.openDate)
                                          }
                                        />
                                      ))}
                                    </>
                                  ) : (
                                    <>
                                      <ExchMobOddView
                                        mainValue={null}
                                        oddType="back-odd"
                                        disable={true}
                                      />
                                      <ExchMobOddView
                                        mainValue={null}
                                        oddType="lay-odd"
                                        disable={true}
                                      />
                                    </>
                                  )
                                ) : (
                                  <>
                                    <ExchMobOddView
                                      mainValue={null}
                                      oddType="back-odd"
                                      disable={true}
                                    />
                                    <ExchMobOddView
                                      mainValue={null}
                                      oddType="lay-odd"
                                      disable={true}
                                    />
                                  </>
                                )}
                              </IonCol>
                            ))}
                          </IonRow>
                        </NavLink>
                      </TableCell>
                      {/* <TableCell className="score-cell" align="center">
                        <div className="score">0</div>
                        <div className="score">0</div>
                      </TableCell> */}
                      {teamTypes.map((teamType, index) => (
                        <TableCell
                          className="odds-cell"
                          align="center"
                          colSpan={2}
                          key={teamType + index}
                        >
                          {sEvent.matchOdds ? (
                            getOdds(sEvent, teamType) ? (
                              <div className="odds-block">
                                {getOdds(sEvent, teamType).map((odd, idx) => (
                                  <ExchOddBtn
                                    key={idx}
                                    mainValue={odd.price}
                                    subValue={odd.size}
                                    oddType={
                                      odd.type === 'back-odd'
                                        ? 'back-odd'
                                        : 'lay-odd'
                                    }
                                    valueType="matchOdds"
                                    showSubValueinKformat={true}
                                    disable={
                                      sEvent.matchOdds.status
                                        .toLowerCase()
                                        .includes('suspended') ||
                                      disableFutureEvents(sEvent.openDate)
                                    }
                                    onClick={() => null}
                                  />
                                ))}
                              </div>
                            ) : (
                              <EmptyOddsBlock />
                            )
                          ) : (
                            <EmptyOddsBlock />
                          )}
                        </TableCell>
                      ))}
                      <TableCell
                        className="all-markets-link-cell"
                        align="right"
                      >
                        <NavLink
                          className="all-markets-nav-link"
                          key={'all-markets-link'}
                          onClick={() => handleEventChange(sEvent)}
                          to={`/exchange_sports/${
                            selectedEventType.slug
                          }/${getCompetitionSlug(sEvent.competitionName)}/${
                            sEvent.eventSlug
                          }/${btoa(
                            `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}`
                          )}`}
                        >
                          <ChevronRightIcon />
                        </NavLink>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : !fetchingEvents ? (
          <div className="events-table-msg-text">No Events to display</div>
        ) : null
      ) : null}
      {/* <IonRow className="footer-row">
        {pageNum === 1 ? null : (
          <IonButton
            className="btn-prev pagination-btn"
            onClick={() => setPageNumber(pageNum - 1)}
            disabled={fetchingEvents}
          >
            Prev({pageNum - 1})
          </IonButton>
        )}
        {events && events.length === pageSize ? (
          <IonButton
            className="btn-next pagination-btn"
            onClick={() => setPageNumber(pageNum + 1)}
            disabled={fetchingEvents}
          >
            Next({pageNum + 1})
          </IonButton>
        ) : null}
      </IonRow> */}
    </div>
  );
};

function EmptyOddsBlock() {
  return (
    <React.Fragment>
      <div className="odds-block">
        <ExchOddBtn mainValue={null} oddType="back-odd" />
        <ExchOddBtn mainValue={null} oddType="lay-odd" />
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  // const pageNum = state.exchangeSports.pageNumebr;
  // const pageSize = state.exchangeSports.pageSize;
  return {
    events: getExchangeEvents(
      state.exchangeSports.events,
      eventType.id,
      competition.id
    ),
    selectedEventType: eventType,
    selectedCompetition: competition,
    // bets: state.exchBetslip.bets,
    // pageNum: pageNum,
    // pageSize: pageSize,
    fetchingEvents: state.exchangeSports.fetchingEvents,
    allowedConfig: state.common.allowedConfig,
    topicUrls: state?.exchangeSports?.topicUrls,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventsByCompetition: (
      sportId: string,
      competitionId: string,
      events: EventDTO[]
    ) => dispatch(fetchEventsByCompetition(sportId, competitionId, events)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    // addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
    fetchEventsBySport: (sportId: string, events: EventDTO[]) =>
      dispatch(fetchEventsBySport(sportId, events)),
    // setPageNumber: (pageNum: number) => dispatch(setPageNumber(pageNum)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsTable);
